var React = require('react');

function Fit (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icoFit"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"icoFit","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("path",{"d":"M17.75,12.5 L17.75,17.75 L12.5,17.75 L14.516,15.734 L11.975,13.235 L13.235,11.975 L15.734,14.516 L17.75,12.5 Z M7.25,17.75 L2,17.75 L2,12.5 L4.016,14.516 L6.515,11.975 L7.775,13.235 L5.234,15.734 L7.25,17.75 Z M2,7.25 L2,2 L7.25,2 L5.234,4.016 L7.775,6.515 L6.515,7.775 L4.016,5.234 L2,7.25 Z M12.5,2 L17.75,2 L17.75,7.25 L15.734,5.234 L13.235,7.775 L11.975,6.515 L14.516,4.016 L12.5,2 Z","fill":"#FCB34E"}))]);
}

Fit.defaultProps = {"width":"20px","height":"20px","viewBox":"0 0 20 20","version":"1.1"};

module.exports = Fit;

Fit.default = Fit;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/icons/fit.svg
// module id = 932
// module chunks = 0